import React from 'react';
import { Images } from 'utils';
import { SIGNATURE_REQUEST_ERROR } from './constants';

const MESSAGES = {
    [SIGNATURE_REQUEST_ERROR.EXPIRED]: {
        title: 'This link has expired',
        text: 'Signature links are valid for 7 days. Please contact your provider to receive a new one.',
    },
    [SIGNATURE_REQUEST_ERROR.NOT_FOUND]: {
        title: 'This link is no longer active',
        text: 'The request linked here has either been cancelled or is no longer valid.',
    },
    [SIGNATURE_REQUEST_ERROR.INVALID_TYPE]: {
        title: 'This link is not valid',
        text: 'Please open the link exactly as it appears in the email from your provider.',
    },
    [SIGNATURE_REQUEST_ERROR.NO_TOKEN]: {
        title: 'This link is not valid',
        text: 'Please open the link exactly as it appears in the email from your provider.',
    },
};

const ALREADY_HANDLED = {
    icon: 'signedSuccessCheck',
    title: 'This request has already been signed',
    text: 'Nothing more is needed from you. Your provider has already received the signature.',
};

const FALLBACK = {
    title: 'Something went wrong',
    text: 'We could not load this signature request. Please try again, or contact your provider.',
};

const getContent = (error) => {
    if (typeof error === 'string' && error.startsWith(SIGNATURE_REQUEST_ERROR.ALREADY_PREFIX)) return ALREADY_HANDLED;
    return MESSAGES[error] || FALLBACK;
};

export const SignatureRequestError = ({ error }) => {
    const { icon, title, text } = getContent(error);

    return (
        <div className="signature-request-error">
            <img src={icon ? Images[icon] : Images.alertError} alt="status" />
            <p className="signature-request-error-title">{title}</p>
            <span className="signature-request-error-text">{text}</span>
        </div>
    );
};
